export const Marquee = ({ items, className = "" }) => {
    // Duplicate items to create a seamless loop
    const looped = [...items, ...items];
    return (
        <div className={`relative w-full overflow-hidden ${className}`} data-testid="marquee">
            <div className="marquee-track py-2">
                {looped.map((item, i) => (
                    <span
                        key={i}
                        className="flex items-center gap-8 pr-8 font-display italic text-6xl md:text-8xl lg:text-9xl whitespace-nowrap"
                    >
                        <span>{item}</span>
                        <span className="text-brand-red not-italic">✽</span>
                    </span>
                ))}
            </div>
        </div>
    );
};
